module.exports = __webpack_public_path__ + "img/login-left-illustration.c2386ebd.png";